import { render, staticRenderFns } from "./InspirationalTile.vue?vue&type=template&id=19b84758&scoped=true&"
import script from "./InspirationalTile.vue?vue&type=script&lang=ts&"
export * from "./InspirationalTile.vue?vue&type=script&lang=ts&"
import style0 from "./InspirationalTile.vue?vue&type=style&index=0&id=19b84758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b84758",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,IconsArrowrightArrowRight16px: require('/var/www/packages/theme/components/icons/arrowright/ArrowRight16px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,MoleculesCmsCustomButtonWrapper: require('/var/www/packages/theme/components/molecules/CmsCustomButtonWrapper.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
